import { render, staticRenderFns } from "./RegistrationLoginForm.vue?vue&type=template&id=dd8021c8&"
import script from "./RegistrationLoginForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports